<button
  *ngIf="value"
  type="button"
  class="sales-order-clickable-cell__wrapper linkish"
  (click)="onClickEvent()"
  >{{ value }}</button
>
